/**
 * API Keys Hook
 * API გასაღებების ჰუკი
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getApiKeys,
  getApiKey,
  createApiKey,
  revokeApiKey,
  deleteApiKey,
  type CreateApiKeyRequest,
} from '../features/api/apiKeys';

export function useApiKeys() {
  const query = useQuery({
    queryKey: ['api-keys'],
    queryFn: () => getApiKeys(),
  });

  return {
    apiKeys: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useApiKey(keyId: string) {
  const query = useQuery({
    queryKey: ['api-key', keyId],
    queryFn: () => getApiKey(keyId),
    enabled: !!keyId,
  });

  return {
    apiKey: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateApiKeyRequest) => createApiKey(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
}

export function useRevokeApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (keyId: string) => revokeApiKey(keyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (keyId: string) => deleteApiKey(keyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
}
